import Vue from 'vue'

export default Vue.extend({
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: '',
      required: false,
    },
    variant: {
      type: String,
      default: 'error',
      required: false,
    },
  },
})
